export default "__VITE_ASSET__Dn0pUZm1__"